<template>
    <v-container>
        <template>
            <ChartLayout></ChartLayout>
        </template>
    </v-container>
</template>



<script>
    // import { mapActions, mapGetters } from "vuex";
    import ChartLayout from './ChartLayout.vue';

    export default {
        
        components: {
            ChartLayout,
        },
    }

</script>